import React from 'react';

// Components
import { WpContainer, WpContainerHeader, WpContainerBody, WpContainerFooter } from 'Wpds/components/container';
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './TopicLoading.scss';

const TopicLoading = () => {
  const baseClassName = 'TopicLoading';
  return (
    <div className={`${baseClassName}`}>
      <WpContainer className={`${baseClassName}__topic`}>
        <WpContainerHeader>
          <div className={`${baseClassName}__topic__header`}>
            <div className={`${baseClassName}__topic__header__avatar`}>
              <LoadingShimmer shape="circle" width="24px" height="24px" />
            </div>
            <LoadingShimmer shape="rectangle" width="100px" height="16px" />
          </div>
        </WpContainerHeader>
        <WpContainerBody>
          <div className={`${baseClassName}__topic__body`}>
            <LoadingShimmer shape="rectangle" width="200px" height="16px" />
            <div className={`${baseClassName}__topic__body__topic`}>
              <LoadingShimmer shape="rectangle" width="300px" height="27px" />
            </div>
          </div>
        </WpContainerBody>
        <WpContainerFooter justifyContent="spaceBetween">
          <LoadingShimmer shape="square" width="100px" height="32px" />
          <LoadingShimmer shape="square" width="100px" height="32px" />
        </WpContainerFooter>
      </WpContainer>
      <WpContainer className={`${baseClassName}__extra`}>
        <WpContainerHeader>
          <LoadingShimmer shape="rectangle" width="100px" height="16px" />
        </WpContainerHeader>
        <WpContainerBody>
          <div className={`${baseClassName}__extra__body`}>
            <div className={`${baseClassName}__extra__body__text`}>
              <LoadingShimmer shape="rectangle" width="200px" height="16px" />
            </div>
            <div className={`${baseClassName}__extra__body__text`}>
              <LoadingShimmer shape="rectangle" width="150px" height="16px" />
            </div>
          </div>
        </WpContainerBody>
      </WpContainer>
      <WpContainer className={`${baseClassName}__extra`}>
        <WpContainerHeader>
          <LoadingShimmer shape="rectangle" width="100px" height="16px" />
        </WpContainerHeader>
        <WpContainerBody>
          <div className={`${baseClassName}__extra__body`}>
            <div className={`${baseClassName}__extra__body__text`}>
              <LoadingShimmer shape="rectangle" width="200px" height="16px" />
            </div>
            <div className={`${baseClassName}__extra__body__text`}>
              <LoadingShimmer shape="rectangle" width="150px" height="16px" />
            </div>
          </div>
        </WpContainerBody>
      </WpContainer>
    </div>
  );
};

export default TopicLoading;
